import type { OnyxPagination } from '@onyx/angular';

export const SHORT_PAGINATION: OnyxPagination = {
  page: 1,
  limit: 10,
};
